function createGoof({message,type,data,validations}){return{message,type,data,name:"Goof",validations}}export{createGoof};
